import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { CContainer, CRow, CCol, CCard, CCardBody, CButton } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilBan } from '@coreui/icons'

const ModuleDisabled = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { moduleName } = location.state || {}

  return (
    <CContainer>
      <CRow className="justify-content-center">
        <CCol md={6}>
          <CCard className="p-4">
            <CCardBody className="text-center">
              <CIcon icon={cilBan} size="3xl" className="text-danger mb-3" />
              <h2>Module Non Disponible</h2>
              <p className="text-medium-emphasis">
                {moduleName
                  ? `Le module ${moduleName} est actuellement désactivé.`
                  : 'Ce module est actuellement désactivé.'}
                <br />
                Veuillez contacter un administrateur pour plus d'informations.
              </p>
              <CButton color="primary" onClick={() => navigate('/dashboard')}>
                Retour au tableau de bord
              </CButton>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  )
}

export default ModuleDisabled
